export var Errors = {
    // eslint-disable @typescript-eslint/naming-convention
    ACCESS_DENIED: 'ACCESS_DENIED',
    AWS_ERROR: 'AWS_ERROR',
    DUPLICATE_URLSLUG: 'DUPLICATE_URLSLUG',
    DUPLICATE_DISPLAYNAME: 'DUPLICATE_DISPLAYNAME',
    DUPLICATE_FILENAME: 'DUPLICATE_FILENAME',
    INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
    INVALID_PARAMETER: 'INVALID_PARAMETER',
    IMAGE_TOO_LARGE: 'IMAGE_TOO_LARGE',
    MISSING_PROPERTY: 'MISSING_PROPERTY',
    NOT_FOUND: 'NOT_FOUND',
    PIN_NOT_FOUND: 'PIN_NOT_FOUND',
    CONFIG_ERROR: 'CONFIG_ERROR',
    REDIS_ERROR: 'REDIS_ERROR',
    SERVER_ERROR: 'SERVER_ERROR',
    SQL_ERROR: 'SQL_ERROR',
    USER_DISABLED: 'USER_DISABLED',
    TIMEOUT: 'TIMEOUT',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    AUTH_CODE_EXPIRED: 'AUTH_CODE_EXPIRED',
    FILE_PARSE_ERROR: 'FILE_PARSE_ERROR',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    FORBIDDEN: 'FORBIDDEN',
    LOGIN_TOO_SHORT: 'LOGIN_TOO_SHORT',
    LOGIN_INVALID: 'LOGIN_INVALID',
    INVALID_EMAIL: 'INVALID_EMAIL',
    PASSWORD_RETIRED: 'PASSWORD_RETIRED',
    PASSWORD_TOO_WEAK: 'PASSWORD_TOO_WEAK',
    PASSWORD_INCORRECT: 'PASSWORD_INCORRECT',
    PASSWORD_ALGORITHM_FAILURE: 'PASSWORD_ALGORITHM_FAILURE',
    PASSWORD_REQUIRED: 'PASSWORD_REQUIRED',
    SSO_ERROR: 'SSO_ERROR',
    INVALID_SSO_PROVIDER: 'INVALID_SSO_PROVIDER',
    EMAIL_TOO_LONG: 'EMAIL_TOO_LONG',
    DUPLICATE_EMAIL: 'DUPLICATE_EMAIL',
    DUPLICATE_LOGIN: 'DUPLICATE_LOGIN',
    DUPLICATE_KEY: 'DUPLICATE_KEY',
    VALUE_TOO_LONG: 'VALUE_TOO_LONG',
    UNKNOWN_PARAMETER: 'UNKNOWN_PARAMETER',
    MISSING_PARAMETER: 'MISSING_PARAMETER',
    PROVIDER_ERROR: 'PROVIDER_ERROR',
    INCORRECT_AUTH_CODE: 'INCORRECT_AUTH_CODE',
    MISSING_AUTH_CODE: 'MISSING_AUTH_CODE',
    IN_USE: 'IN_USE',
    TFA_REQUIRED: 'TFA_REQUIRED',
};
